export const ROUTERS = {
	HOME: 'home',
	DASHBOARD: {
		MAIN: 'dashboard',
		FRANQUIA: 'dashboard.franquia',
		ANALISTA_CREDITO_IMOBILIARIO: 'dashboard.AnalistaCreditoImobiliario',
		PRODUTIVIDADE: 'dashboard.RankingProdutividade',
		PROJECOES: 'dashboard.projecoes'
	},

	LOGIN: 'login',

	ADMINISTRATIVO: {
		PARAMETRIZACOES: {
			CANAL_FRANQUIA: 'canalFranquia',
			CREDITO_IMOBILIARIO: 'creditoImobiliario',
			CAPITALIZACAO: 'capitalizacao',
			META_CONSULTORES: 'MetaConsultores',
			CANAL: 'Canal'
		},
		PARCEIROS: 'administrativo.parceiros',
		PARCEIROS_VINCULACAO: 'administrativo.parceiros-padrao.vinculacao',
		PARCEIRO: 'administrativo.parceiros.parceiro',
		CORRETORES: 'administrativo.corretores',
		GRUPO_VINCULO_PARCEIRO: 'administrativo.grupoVincularParceiro',
		PARCEIROS_EMISSAO_ADD: 'administrativo.seguradoras.parceiros-emissao.add',
		PARCEIROS_EMISSAO: 'administrativo.seguradoras.parceiros-emissao',
		MONITORAMENTO: {
			ROBOS: 'administrativo.monitoramento.robos'
		},
		ROTINAS: {
			MIGRACAO: {
				RESPONSAVEL: 'administrativo.rotina.migracao',
				FRANQUIA: 'administrativo.rotina.franquia',
				ANALISTA: 'administrativo.rotina.analista'
			}
		},
		USUARIOS: 'administrativo.usuario',
		ACIONAMENTO: 'administrativo.acionamento'
	},

	LEADS: {
		CADASTRO: 'lead.cadastro'
	},

	MINHAS_PROPOSTAS: 'minhasPropostas',

	ANALISE_CREDITO: {
		DEFAULT: 'analiseCredito',
		NOVA: 'analiseCredito.nova',
		VISUALIZAR: 'analiseCredito.visualizar'
	},

	CREDITO_IMOBILIARIO: {
		PRE_ANALISE: {
			GERENCIAR: 'pre-analise.gerenciar',
			NOVA: 'pre-analise.nova',
			RESULTADO: 'pre-analise.nova.resultado',
			DETALHES: 'pre-analise.detalhes',
			FORMULARIO_MULTIBANCOS: 'pre-analise.formulario'
		},

		SIMULADOR: {
			MAIN: 'creditoImobiliario.simulador',
			NOVO: 'novo.creditoImobiliario.simulador',
			RESULTADO: 'creditoImobiliario.simulador.resultado'
		}
	},

	PROPOSTAS: {
		PROPOSTA: 'proposta.proposta',
		LISTA: 'proposta.propostas'
	},

	DECISOES: {
		DECISOES_EXTERNAS: 'decisoes.externas'
	},

	CARTA_FIANCA: {
		EXTERNO: 'carta.fianca.externo'
	},

	CUSTOMER_SATISFACTION: 'customerSatisfaction',

	CLOSING: 'closing',
	CLOSING_MINUTAS_REPORT: 'closing.minutas-report',

	ACCOUNT: {
		SELECT_USER: 'selectUser'
	}
}

export default ROUTERS
